import constants from 'src/constants/constants';
import apiAuth from 'src/clients/apiAuth';
import {
  LOAD,
  DOWNLOAD,
  DOWNLOADGROUPED,
  RELOAD,
  GET_ADMIN_DEMANDS,
  CANCEL_DEMAND_ACTION,
  DEMANDS,
  GET_DEMANDS_GROUPED_BY_SKU,
} from 'src/store/actionTypes';
import {
  FAILED,
  LOADING,
  CANCEL_DEMAND,
  POPULATE_DEMANDS,
  FULFILL_DEMAND,
  REQUEST_DEMAND,
  UNREQUEST_DEMAND,
  POPULATE_DEMANDS_SKU,
  SET_STATUS,
} from 'src/store/mutationTypes';
import demandApi from 'src/api/server/demands';
import ApiLoadingStatus from 'src/api/statusTypes';
import DEMAND from 'src/constants/demand';
import STATES from 'src/constants/storeObjects';
import { GET_ACTIVE_DEMANDS, GET_ALL, GET_LASTUPDATE } from '../getterTypes';

export default {
  namespaced: true,
  state: {
    all: [],
    groupedBySKU: [],
    lastUpdate: null,
    status: ApiLoadingStatus.STATUS_NOT_INITIALIZED,
  },
  mutations: {
    [CANCEL_DEMAND](state, { demandId }) {
      const indexStock = state.all.findIndex((item) => item.demandId === demandId);
      if (indexStock !== -1) {
        state.all[indexStock].status = DEMAND.STATE.CANCELED;
      }
    },
    [FULFILL_DEMAND](state, { demandId, purchaseOfferId }) {
      const indexStock = state.all.findIndex((item) => item.demandId === demandId);
      if (indexStock !== -1) {
        state.all[indexStock].status = DEMAND.STATE.FULFILLED;
        state.all[indexStock].purchaseOfferId = purchaseOfferId;
      }
    },
    [REQUEST_DEMAND](state, { demandId, purchaseOfferId }) {
      const indexStock = state.all.findIndex((item) => item.demandId === demandId);
      if (indexStock !== -1) {
        state.all[indexStock].status = DEMAND.STATE.REQUESTED;
        state.all[indexStock].purchaseOfferId = purchaseOfferId;
      }
    },
    [UNREQUEST_DEMAND](state, { demandId }) {
      const indexStock = state.all.findIndex((item) => item.demandId === demandId);
      if (indexStock !== -1) {
        state.all[indexStock].status = DEMAND.STATE.ACTIVE;
        state.all[indexStock].purchaseOfferId = null;
      }
    },
    [POPULATE_DEMANDS](state, payload) {
      state.lastUpdate = payload.lastUpdate;
      state.all = payload.demands.map((item) => ({
        ...item,
        _showDetails: false,
        _status: STATES.STATE.IDLE,
        _error: null,
      }));
      state.status = ApiLoadingStatus.STATUS_SUCCESSFUL;
    },
    [POPULATE_DEMANDS_SKU](state, payload) {
      state.lastUpdate = payload.lastUpdate;
      state.groupedBySKU = payload.demands.map((item) => ({
        ...item,
        _showDetails: false,
        _status: STATES.STATE.IDLE,
        _error: null,
      }));
      state.status = ApiLoadingStatus.STATUS_SUCCESSFUL;
    },
    [LOADING](state) {
      state.status = ApiLoadingStatus.STATUS_LOADING;
    },
    [FAILED](state) {
      state.status = ApiLoadingStatus.STATUS_ERROR_LOADING;
    },
    [SET_STATUS](state, payload) {
      const index = state.all.findIndex((item) => item.demandId === payload.demandId);
      if (index !== -1) {
        state.all[index]._status = payload.status;
      }
    },
  },
  actions: {
    async [RELOAD]({ commit }) {
      try {
        commit(LOADING);
        let demands = await demandApi.getDemands();
        commit(POPULATE_DEMANDS, demands);
      } catch (e) {
        commit(FAILED);
      }
    },
    // eslint-disable-next-line no-unused-vars
    async [DOWNLOAD]({ commit }, { fields, diffTax, active }) {
      await demandApi.downloadDemands(fields, diffTax, active);
    },
    // eslint-disable-next-line no-unused-vars
    async [DOWNLOADGROUPED]({ commit }, { fields, diffTax }) {
      await demandApi.downloadDemandsGrouped(fields, diffTax);
    },
    async [LOAD]({ dispatch, state }) {
      if (state.status === ApiLoadingStatus.STATUS_SUCCESSFUL) {
        return;
      }
      return dispatch(RELOAD);
    },
    [GET_ADMIN_DEMANDS]({ commit }) {
      return new Promise((resolve) => {
        let options = {
          baseURL: constants.url.demandService.baseUrl,
          url: constants.url.demandService.api.getActiveDemands,
        };
        apiAuth(options).then((response) => {
          commit(POPULATE_DEMANDS, response.data);
          resolve(response);
        });
      });
    },
    async [GET_DEMANDS_GROUPED_BY_SKU]({ commit }) {
      try {
        commit(LOADING);
        let demands = await demandApi.getDemandsGroupedBySku();
        commit(POPULATE_DEMANDS_SKU, demands);
      } catch (e) {
        commit(FAILED);
      }
    },
    async [DEMANDS.FULFILL](
      { commit },
      {
        demandId,
        purchaseOfferId,
        acceptedPrice,
        acceptedCurrency,
        deliveryDate,
        creditorId,
        orderNumber,
        lineNumber,
        productKey,
        variantKey,
        differentialTaxation,
        userId,
      },
    ) {
      try {
        commit(SET_STATUS, { demandId: demandId, status: STATES.STATE.BUSY });
        await demandApi.fulfillDemand({
          demandId: demandId,
          purchaseOfferId: purchaseOfferId,
          acceptedPrice: acceptedPrice,
          acceptedCurrency: acceptedCurrency,
          deliveryDate: deliveryDate,
          creditorId: creditorId,
          orderNumber: orderNumber,
          lineNumber: lineNumber,
          productKey: productKey,
          variantKey: variantKey,
          differentialTaxation: differentialTaxation,
          userId: userId,
        });
        commit(FULFILL_DEMAND, {
          demandId: demandId,
          purchaseOfferId: purchaseOfferId,
        });
        commit(SET_STATUS, { demandId: demandId, status: STATES.STATE.IDLE });
      } catch (e) {
        // TODO: add error handling
      }
    },
    async [CANCEL_DEMAND_ACTION]({ commit }, { demandId }) {
      try {
        commit(SET_STATUS, { demandId: demandId, status: STATES.STATE.BUSY });
        await demandApi.cancelDemand(demandId);
        commit(CANCEL_DEMAND, { demandId: demandId });
        commit(SET_STATUS, { demandId: demandId, status: STATES.STATE.IDLE });
      } catch (e) {
        // TODO: add error handling
      }
    },
  },
  getters: {
    [GET_ALL]: (state) => {
      return state.all;
    },
    [GET_ACTIVE_DEMANDS]: (state) => {
      return state.all.filter((item) => item.status === DEMAND.STATE.ACTIVE);
    },
    [GET_LASTUPDATE]: (state) => {
      return state.lastUpdate;
    },
  },
};
